import React, {useRef, useState, Children} from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import Popper from "@mui/material/Popper";
import Fade from "@mui/material/Fade";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {RMDButton} from "components/Shared";

const FauxHeaderDropdown = ({
  title,
  children
}) => {
  const ref = useRef();
  const [open, setOpen] = useState(false);
  return (
  <Box>
    <div {...{ref}}>
      <RMDButton onClick={() => setOpen(!open)}>
        {title}
      </RMDButton>
    </div>
    <Popper
      {...{ open }}
      sx={{ zIndex: 1000 }}
      anchorEl={ref.current}
      placement={"bottom-end"}
      transition
      disablePortal
    >
      {({TransitionProps}) => (
        <Fade {...TransitionProps} timeout={350}>
          <div>
            <ClickAwayListener onClickAway={({ target }) => (ref.current && !ref.current.contains(target)) && setOpen(false)}>
              <Box>
                {Children.toArray(children).map((child, index) => (
                  <Box 
                    key={index} 
                    sx={{ 
                      mt: 'var(--padding-10px)', 
                      width: '100%',
                      '& button': { width: '100%' },
                      '& .dropdown-content': { right: 0 }
                    }}
                  >
                    {child}
                  </Box>
                ))}
              </Box>
            </ClickAwayListener>
          </div>
        </Fade>
      )}
    </Popper>
  </Box>
  );
};

FauxHeaderDropdown.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]), 
};

export default FauxHeaderDropdown;